// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operationVideoModal_modal__GRXDx {
  max-width: 880px;
  max-height: 650px;
  position: relative; }

.operationVideoModal_header__fknB6 {
  display: flex;
  justify-content: space-between; }
  .operationVideoModal_header_title__nIjhh {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--HightEmphasis);
    margin-bottom: 10px; }

.operationVideoModal_infoBlock__2ADS0 {
  padding: 10px; }

.operationVideoModal_wrapper__Exbuf {
  display: flex;
  flex-direction: column;
  gap: 5px; }

.operationVideoModal_subtitle__vixQE {
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: var(--MediumEmphasis); }
  .operationVideoModal_subtitle_value__QQadb {
    font-weight: 500;
    color: var(--HightEmphasis); }
    .operationVideoModal_subtitle_value_clipboard__acyB4 {
      font-weight: 500;
      color: var(--Orange);
      cursor: pointer; }

.operationVideoModal_cross__uzBSE {
  position: absolute;
  top: 26px;
  right: 26px;
  color: var(--HightEmphasis);
  cursor: pointer;
  z-index: 1; }
  .operationVideoModal_cross__uzBSE:hover {
    color: var(--MediumEmphasis); }

.operationVideoModal_download__1oKyq {
  position: absolute;
  width: 24px;
  height: 24px;
  padding: 4px;
  bottom: 14px;
  right: 14px;
  color: var(--MediumEmphasis);
  cursor: pointer; }
  .operationVideoModal_download__1oKyq:hover {
    color: var(--HightEmphasis); }
`, "",{"version":3,"sources":["webpack://./src/pages/previewOrders/components/OperationVideoModal/operationVideoModal.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,8BAA8B,EAAA;EAC9B;ICmBA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDnBf,2BAA2B;IAC3B,mBAAmB,EAAA;;AAIvB;EACE,aAAa,EAAA;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;ECuCE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDvCjB,4BAA4B,EAAA;EAC5B;IACE,gBAAgB;IAChB,2BAA2B,EAAA;IAC3B;MACE,gBAAgB;MAChB,oBAAoB;MACpB,eAAe,EAAA;;AAKrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,UAAU,EAAA;EANZ;IAQI,4BAA4B,EAAA;;AAIhC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,eAAe,EAAA;EARjB;IAUI,2BAA2B,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.modal {\n  max-width: 880px;\n  max-height: 650px;\n  position: relative;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  &_title {\n    @include h6;\n    color: var(--HightEmphasis);\n    margin-bottom: 10px;\n  }\n}\n\n.infoBlock {\n  padding: 10px;\n}\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.subtitle {\n  @include caption;\n  color: var(--MediumEmphasis);\n  &_value {\n    font-weight: 500;\n    color: var(--HightEmphasis);\n    &_clipboard {\n      font-weight: 500;\n      color: var(--Orange);\n      cursor: pointer;\n    }\n  }\n}\n\n.cross {\n  position: absolute;\n  top: 26px;\n  right: 26px;\n  color: var(--HightEmphasis);\n  cursor: pointer;\n  z-index: 1;\n  &:hover {\n    color: var(--MediumEmphasis);\n  }\n}\n\n.download {\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  padding: 4px;\n  bottom: 14px;\n  right: 14px;\n  color: var(--MediumEmphasis);\n  cursor: pointer;\n  &:hover {\n    color: var(--HightEmphasis);\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `operationVideoModal_modal__GRXDx`,
	"header": `operationVideoModal_header__fknB6`,
	"header_title": `operationVideoModal_header_title__nIjhh`,
	"infoBlock": `operationVideoModal_infoBlock__2ADS0`,
	"wrapper": `operationVideoModal_wrapper__Exbuf`,
	"subtitle": `operationVideoModal_subtitle__vixQE`,
	"subtitle_value": `operationVideoModal_subtitle_value__QQadb`,
	"subtitle_value_clipboard": `operationVideoModal_subtitle_value_clipboard__acyB4`,
	"cross": `operationVideoModal_cross__uzBSE`,
	"download": `operationVideoModal_download__1oKyq`
};
export default ___CSS_LOADER_EXPORT___;
